/** Caminho público do service worker de cache de shell e assets estáticos. */
export const C_SERVICE_WORKER_SHELL = "/serviceWorkerShell.js"
